<style scoped lang="less">
.sms-content-main {
  background-color: #fff;
  border-radius: 10px;
  padding: 13px 18px 18px 18px;

  //模块标题统一样式
  /deep/ .sms-module-header {
    display: flex;
    align-items: center;
    height: 40px;
    font-weight: bold;
  }

  //控制表格子组件的表头样式
  /deep/ .risk-table-header {
    background-color: #f0f1f7;
    border: 0 !important;
    padding: 5px 0;
    color: #000;
    font-size: 13px;
  }
}

.sms-content-main:not(:first-child) {
  margin-top: 20px;
}

.core-risk-box {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.sms-cell-box {
  height: 100px;
  width: calc((100% - 132px) / 9);
  border-radius: 10px;
  box-shadow: 0 0 10px #f0f1f7;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

/*计算margin，每行9个块，每个10.5%宽，每行8个margin*/
/*.sms-cell-box:not(:nth-child(9n)) {
  margin-right: ((100%-(10.7%*9))/8);
}*/

.sms-cell-box:hover {
  cursor: pointer;
  transition: box-shadow 618ms;
  box-shadow: 0 0 17px #000;
}

.card-active {
  color: #fff;
  background-color: #34405c;
}

/*从第9个开始，都有上边距*/
/*.sms-cell-box:nth-child(n+10) {
  margin-top: 10px;
}*/

.risk-table-box {
  background-color: #f0f1f7;
  padding: 0 14px 35px 18px;

  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 3px;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #c8c8c8;
  }

  //表体单元格
  /deep/ .cell-class {
    font-size: 12px;
    padding: 5px 0;
  }
}

.core-risk-warn {
}

.core-risk-month {
  margin-top: 30px;

  .year-wrapper {
    margin-left: 20px;

    .el-date-editor {
      width: 185px;
    }
  }
}

//核心风险 - 危险源
.core-risk-danger {
  margin-top: 5px;
}

.core-risk-kpi {
  margin-top: 15px;

  .sms-module-header {

    .kpi-prefix-box {
      display: flex;
      align-items: center;
      height: 35px;
      border-radius: 5px;
      padding-left: 7px;

      .el-icon-error {
        display: none;
        padding: 3px;
        cursor: pointer;
      }
    }

    .kpi-prefix-box-dynamic {
      &:hover {
        background-color: #35425d;
        color: #fff;
        padding-right: 7px;
      }

      &:hover .el-icon-error {
        display: block;
      }
    }
  }
}
</style>

<template>
  <div v-title data-title="核心风险">
    <div class="sms-content-main">
      <div class="core-risk-box" ref="coreRiskBox">
        <div class="sms-cell-box" v-for="item in cardData" :key="item.code"
             :class="{'card-active':coreRisk.code===item.code}"
             @click="onCardClick(item)">
          <CoreRiskCard :core-risk="item"></CoreRiskCard>
        </div>
      </div>
      <div class="core-risk-month">
        <div class="sms-module-header">
          {{ coreRisk.name }}-月度管控状态
          <!--          {{ this.coreRisk.code }}-->
          <!--          {{ this.danger }}-->
          <!--          {{ this.insecurity }}-->
          <div class="el-date-picker-wrapper year-wrapper">
            <el-date-picker v-model="year" type="year" format="yyyy年" value-format="yyyy" :clearable="false"
                            :editable="false" placeholder="选择年">
            </el-date-picker>
          </div>
        </div>
        <CoreRiskMonth v-if="coreRisk.code" :coreRisk="coreRisk.code" :year="Number(year)"></CoreRiskMonth>
      </div>

      <div class="core-risk-danger">
        <div class="sms-module-header">
          {{ coreRisk.name }}-关联危险源
          <!--          {{ this.kpi }}-->
        </div>
        <div class="risk-table-box">
          <CoreRiskDanger v-if="coreRisk.code" :coreRisk="coreRisk.code" :danger.sync="danger"
                          :insecurity.sync="insecurity"></CoreRiskDanger>
        </div>
      </div>
      <div class="core-risk-kpi">
        <div class="sms-module-header">
          <!-- 存在该样式时kpi-prefix-box-dynamic，鼠标悬浮出现移除按钮  -->
          <div class="kpi-prefix-box" :class="{ 'kpi-prefix-box-dynamic': kpi.prefix.remove }">
            <p>{{ kpi.prefix.name }}</p>
            <i class="el-icon-error" @click="removeKpiPrefix"></i>
          </div>
          -关联KPI指标
        </div>
        <div class="risk-table-box">
          <CoreRiskKpi v-if="coreRisk.code && kpi.enable"
                       :coreRisk="coreRisk.code"
                       :dangerId="danger.id"
                       :year="Number(year)"
                       :insecurity="insecurity.code"
                       :kpiCode.sync="kpi.code"></CoreRiskKpi>
        </div>
      </div>
    </div>
    <!-- 当KPI存在时，才加载 -->
    <div class="sms-content-main" v-if="kpi.code">
      <div id="kpiChart" class="core-risk-warn">
        <KpiChart :kpiCode="kpi.code" :year="Number(year)"></KpiChart>
      </div>
    </div>
  </div>
</template>

<script>
import CoreRiskMonth from "./risk/CoreRiskMonth";
import CoreRiskDanger from "./risk/CoreRiskDanger";
import CoreRiskKpi from "./risk/CoreRiskKpi";
import KpiChart from "./risk/KpiChart";
import CoreRiskCard from "./risk/CoreRiskCard";
import {getRequest} from "../../utils/request";

export default {
  props: {
    company: String,
  },
  data() {
    return {
      //卡片数据
      cardData: [],
      //核心风险
      coreRisk: {
        code: null,
        name: null,
      },
      //典型事件
      insecurity: {
        code: null,
        name: null,
      },
      //危险源
      danger: {
        id: null,
        num: null,
      },
      //KPI
      kpi: {
        //与coreRisk.code共同控制关联kpi组件
        enable: true,
        name: null,
        code: null,
        prefix: {
          //前缀（默认为核心风险名称）
          name: null,
          //前缀可否被移除
          remove: false,
        },
      },
      //年份，默认今年
      year: String(new Date().getFullYear()),
    }
  },
  mounted() {
    this.buildCard();
  },
  methods: {
    buildCard() {
      this.coreRisk = {code: null, name: null};
      this.cardData = [];
      getRequest("risk/core/cards", {}, this.$refs.coreRiskBox).then(res => {
        this.cardData = res.data;

        //已指定某个核心风险时，使用指定的；未选择任何核心风险时，默认激活第1个核心风险
        let coreRisk = this.$route.query.code ? this.cardData.find(item => item.code === this.$route.query.code) : this.cardData[0];
        //code设置后，月度管控、危险源、kpi开始加载
        this.coreRisk = Object.assign({}, this.coreRisk, coreRisk)
        //注：这里需要先执行，后续如果存在danger，可能会覆盖
        this.setCoreRiskKpiPrefix();
        //设置默认值
        if (this.$route.query.dangerId && this.$route.query.dangerNum)
          this.danger = {id: Number(this.$route.query.dangerId), num: this.$route.query.dangerNum};
        if (this.$route.query.year)
          this.year = this.$route.query.year;
        if (this.$route.query.kpiCode)
          //先确保关联kpi加载完成
          this.$nextTick(() => {
            this.kpi.code = this.$route.query.kpiCode;
            //滚动到锚点（更新kpi.code触发v-if，确保dom渲染后再hash）
            this.$nextTick(() => location.hash = "kpiChart")
          })
      })
    },
    /**
     * 核心风险卡片切换
     * 1.禁用kpi
     * 2.重置典型事件和危险源（这样kpi不会因为它俩触发watch）
     * 3.更新核心风险
     * 4.启用kpi
     */
    onCardClick(coreRisk) {
      this.kpi.enable = false;
      this.$nextTick(() => {
        this.resetInsecurityAndDangerWithoutWatch();
        this.coreRisk = Object.assign({}, this.coreRisk, coreRisk)
        this.kpi.enable = true;
        this.setCoreRiskKpiPrefix();
      })
    },
    /**
     * 移除kpi前缀
     * 1.禁用kpi
     * 2.重置典型事件和危险源（这样kpi不会因为它俩触发watch）
     * 3.启用kpi
     */
    removeKpiPrefix() {
      this.kpi.enable = false;
      this.$nextTick(() => {
        this.resetInsecurityAndDangerWithoutWatch();
        this.kpi.enable = true;
        this.setCoreRiskKpiPrefix();
      })
    },
    /**
     * 安全的重置典型事件和危险源
     * 这里不触发danger和insecurity的watch
     */
    resetInsecurityAndDangerWithoutWatch() {
      this.insecurity.code = null;
      this.insecurity.name = null;
      this.danger.id = null;
      this.danger.num = null;
    },
    setCoreRiskKpiPrefix() {
      this.kpi.prefix.name = this.coreRisk.name;
      this.kpi.prefix.remove = false;
    },
  },
  watch: {
    danger() {
      this.kpi.prefix.name = this.danger.num + "危险源";
      this.kpi.prefix.remove = true;
    },
    insecurity() {
      this.kpi.prefix.name = this.insecurity.name;
      this.kpi.prefix.remove = true;
    },
    company() {
      this.buildCard();
    }
  },
  computed: {}
  ,
  components: {
    CoreRiskMonth,
    CoreRiskDanger,
    CoreRiskKpi,
    KpiChart,
    CoreRiskCard,
  }
}
</script>



// WEBPACK FOOTER //
// src/components/achievement/CoreRisk.vue